import { useEffect, useState } from 'react'
import { Table, Tree, Checkbox, Modal } from 'antd'
import { YhBox } from "@components/YhBox";
import type { TreeProps } from 'antd/es/tree';
import { ColumnsType } from "antd/es/table";
import { useRoleModel } from "../roleModel";
import { roleService } from "../RoleService";
import { IRoleColumn, IRoleColumnDetail } from "../RoleTypes";
import { detailColumnTree, detailColumns } from "./constants";
import './detailColumn.less'

const DetailColumn = () => {

    const [model, setModel] = useState<string>();
    const [dataSource, setDataSource] = useState<IRoleColumnDetail[]>([]);
    const { selectedRowData, setRoleColumnData } = useRoleModel();

    useEffect(() => {
        if (dataSource != null && dataSource.length > 0) {
            const data = dataSource.map(e => {
                const { id, ...item } = e;
                return item;
            });
            setRoleColumnData({
                "roleCode": selectedRowData?.code ?? "",
                "code": model,
                "val": JSON.stringify(data)
            });
        }
    }, [dataSource, model])

    const onSelect: TreeProps['onSelect'] = (selectedKeys, info) => {
        setDataSource([]);
        const code = selectedKeys[0];
        setModel(code.toString());
        if (code != null && selectedRowData != null) {
            const roleCode = selectedRowData.code ?? "";
            roleService.authColumnOne(roleCode, code.toString()).then((ret) => {
                const { retData } = ret;
                const allColumns: IRoleColumnDetail[] = detailColumns.filter(e => e.model === code.toString())
                if (retData == null) {
                    Modal.confirm({
                        title: '系统提示',
                        centered: true,
                        closable: true,
                        content: <div><span style={{ color: 'red' }}>{info.node.title}</span>即将初始化,请注意保存数据！</div>,
                        onOk() {
                            const newList = allColumns.map(e => ({ ...e, id: ((e.model ?? "") + e.code + e.type) }));
                            setDataSource(newList);
                        },
                    })
                }
                else {
                    const list: IRoleColumnDetail[] = JSON.parse(retData.val ?? "[]");
                    if (list.length < allColumns.length) {
                        // 创建 ID 映射用于快速查找
                        const listIdSet = new Set(list.map(e => (e.model ?? "") + e.code + e.type));
                        // 合并并保持 allColumns 的顺序
                        const mergedList = [
                            ...list,
                            ...allColumns.filter(e => !listIdSet.has((e.model ?? "") + e.code + e.type))
                        ];
                        // 按照 allColumns 的顺序重新排序
                        const orderedList = allColumns.map(col =>
                            mergedList.find(e => (e.model ?? "") + e.code + e.type === (col.model ?? "") + col.code + col.type)!
                        );
                        list.splice(0, list.length, ...orderedList);
                    }
                    const newList = list.map(e => ({ ...e, id: ((e.model ?? "") + e.code + e.type) }));
                    setDataSource(newList);
                }
            }).catch((err) => { })
        }
    };

    const columns: ColumnsType<any> = [
        {
            title: '序号',
            align: "center",
            width: 60,
            render: (v, r, i) => i + 1
        },
        {
            title: '类型',
            dataIndex: 'type',
            align: "center",
            width: 80,
        },
        {
            title: '列名称',
            dataIndex: 'name',
            align: "center",
        },
        {
            title: '是否显示',
            dataIndex: 'showable',
            align: "center",
            width: 80,
            render(t, r) {
                return (
                    <Checkbox
                        key={r.id}
                        checked={r.showable == "0" ? false : true}
                        onChange={(e) => {
                            handleSave({ ...r, showable: e.target.checked ? "1" : "0" })
                        }}
                    />
                )
            },
        },
        {
            title: '是否编辑',
            dataIndex: 'editable',
            align: "center",
            width: 80,
            render(t, r) {
                if (t != undefined && t != null) {
                    return (
                        <Checkbox
                            key={r.id}
                            checked={r.editable == "0" ? false : true}
                            onChange={(e) => {
                                handleSave({ ...r, editable: e.target.checked ? "1" : "0" })
                            }}
                        />
                    )
                }
                else {
                    return <></>;
                }
            },
        },
    ]

    const handleSave = (row: IRoleColumn) => {
        const newData = [...dataSource]
        const index = newData.findIndex((item) => row.id === item.id)
        const item = newData[index]
        newData.splice(index, 1, { ...item, ...row })
        setDataSource(newData);
    }

    return (
        <>
            <div className="container">
                <div className="child left">
                    <YhBox width="100%" height="100%" title={<span style={{ fontSize: 20 }}>菜单名称</span>} style={{ height: 590, border: "1px solid #d6d6d6", overflow: 'auto' }}>
                        <Tree.DirectoryTree
                            className="p-5"
                            defaultExpandAll={true}
                            showLine={false}
                            showIcon={false}
                            treeData={detailColumnTree}
                            onSelect={onSelect}
                        />
                    </YhBox>
                </div>
                <div className="child right">
                    <YhBox width="100%" height="100%" title="" style={{ height: 590, border: "1px solid #d6d6d6", overflow: 'auto' }}>
                        <Table
                            rowKey={record => record.id}
                            columns={columns}
                            dataSource={dataSource}
                            pagination={false}
                            scroll={{ x: 'max-content' }}
                        />
                    </YhBox>
                </div>
            </div >
        </>
    )
}


export default DetailColumn;